import {ArticleDto, CategorieDto} from "@resources/resources";
import {ActivatedRoute} from "@angular/router";
import {Component} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ArianeStore} from "@digicerba/common";

@Component({
  selector: 'gestion-articles',
  templateUrl: './gestion.articles.component.html',
  host: {'class': 'page'}
})
export class GestionArticlesComponent {

  articles: ArticleDto[];
  categorie: CategorieDto;

  constructor(private arianeStore: ArianeStore, private translateService: TranslateService, private activatedRoute: ActivatedRoute) {
  }

  private initArianne(categorie: CategorieDto) {
    let arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/"
      },
      {
        libelle: "ARIANNE.CATEGORIES.categories",
        route: "/categories/liste"
      },
      {
        libelle: this.translateService.instant("ARIANNE.CATEGORIES.category", {identifiant: categorie.libelle.fr}),
        route: "/categories/categorie/" + categorie.id
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((paramsMap) => {
      this.articles = this.activatedRoute.snapshot.data['articles'];
      this.categorie = this.activatedRoute.snapshot.data['categorie'];
      this.initArianne(this.categorie);
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/gestion-articles/gestion.articles.component.ts